import { useContext, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Form, FormContext, Text } from "dash-ui";

import { FormFields } from "containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants";
import useValidation from "containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation";

import AverageUnitValueInput from "./components/AverageUnitValueInput";
import { joditConfig } from "v2/constants/constants";
import JoditEditor from "jodit-react";
import { GetPropertyByIdQuery } from "gql/generated.graphql";

const InventoryInfo = ({
  property,
}: {
  property: GetPropertyByIdQuery["getPropertyById"];
}) => {
  const { t } = useTranslation("forms");
  const { stateHandlers, formErrors } = useContext(FormContext);
  const validate = useValidation();
  const inventoryDetailsEditor = useRef<any>(null);

  const handleInventoryValue = (value: string) => {
    stateHandlers[FormFields.DefaultInventoryDetails](value);
    validate(FormFields.DefaultInventoryDetails, value);
  };

  const config: any = joditConfig;

  return (
    <Box mt={4}>
      <Text semibold lg>
        {t("labels.inventoryInfo")}
      </Text>
      <Flex w="100%">
        <Flex flex={1} mr={2}>
          <Form.Group mt={4} w="100%">
            <Form.Label>{t("labels.defaultInventoryDetails")}</Form.Label>
            {
              //  Return memoized HTML component to avoid Jodit's bug on use "onChange" property.
            }
            {useMemo(
              () => (
                <JoditEditor
                  ref={inventoryDetailsEditor}
                  value={property.defaultInventoryDetails || ""}
                  onChange={handleInventoryValue}
                  config={{
                    ...config,
                    placeholder: t("placeholders.defaultInventoryPlaceholder"),
                  }}
                />
              ),
              []
            )}
            <Form.Feedback
              $errorType={formErrors[FormFields.DefaultInventoryDetails]?.type}
            >
              {formErrors[FormFields.DefaultInventoryDetails]?.message}
            </Form.Feedback>
          </Form.Group>
        </Flex>
        <Flex flex={1} mr={2}>
          <AverageUnitValueInput required={false} fieldKey="bedrooms" />
        </Flex>
        <AverageUnitValueInput required={false} fieldKey="bathrooms" />
      </Flex>
    </Box>
  );
};

export default InventoryInfo;
